import { component } from 'picoapp';

export default component(async (node) => {
  const hasReferrer = document.referrer !== window.location.href;

  if (!hasReferrer) {
    return;
  }

  node.hidden = false;

  node.addEventListener('click', () => {
    window.history.back();
  });
});
